/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.10.1
 */
import { C as ComboboxItem, d as defineCustomElement$1 } from './combobox-item.js';

const CalciteComboboxItem = ComboboxItem;
const defineCustomElement = defineCustomElement$1;

export { CalciteComboboxItem, defineCustomElement };

//# sourceMappingURL=calcite-combobox-item.js.map